var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mdn"},[_c('NewCard',{attrs:{"kota":_vm.namakota,"hari":_vm.hari,"ymd":_vm.ymd,"sholat":_vm.paramsSholat,"lhk":_vm.lhkinfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }